import z from "zod"

export const stockStatusValues = ["IN_STOCK", "IN_USE", "INCOMING", "REMOVED"] as const

export const stockStatusSchema = z.enum(stockStatusValues)
export type StockStatus = z.infer<typeof stockStatusSchema>
